import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { RPDMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RPDCloums';
import { tableDataFormatKMB, pageAble } from '@/pages/intelligence/utils/commonUtils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { CountriesShareColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CountriesShareCloums';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    chartSegment,
    asForDate = '',
    regionSegVal,
    fixedTableData,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    entityType,
    dataSource,
  } = props;
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  // const [pageSize, setPageSize] = useState(15);
  const [pageSize, setPageSize] = useState(50);
  const { rpdListDetail } = useMobileOptionList({ asForDate });

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };
  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
    });
    const pageList = pageAble(sortTable, pageIndex, pageSize);
    // setPageSortTable(pageList);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    setSortTableData(sortTable.slice(0));
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metrics = cvm?.metrics || [];
    const metric = metrics.find((item: any) => {
      return item?.name === metricKey;
    });
    return tableDataFormatKMB(metric?.value);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];

    rpdListDetail.forEach((t) => {
      metricCloums.push(
        RPDMetricColumn(
          {
            width: t.width,
            width_cn: t?.width_cn ?? t.width,
            // dataSource: source, //source === 'ogdb' ? 'databarin' : source,
            title: t.title,
            textContent: t.textContent,
            key: `${t.key}`,
            metricKey: t?.metricKey || t?.key,
            sortMetric: t.key,
            isNoDropdown: !(chartSegment === t.key) || sortTableData?.length === 1,
            currentSortValue: pageSortAttr?.currentSortValue,
            currentSortKey: `${pageSortAttr?.currentSortMetric}`,
            onSortChage: handleSortChange,
            getMetricValueOfCvm,
            entityType,
          },
          dataSource,
        ),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    // setPageSize(e.pageSize || 5);
    setPageSize(e.pageSize || 50);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex, e.pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    // setPageSortTable(pageList);
  };

  return (
    <>
      <TopchartTable
        className="dbi-mobileGames-details-table"
        loading={loading}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        // pageSizeOptions={[5, 10, 15]}
        pageSizeOptions={[10, 20, 30, 50, 100, 200]}
        // scrollMaxHeight={'calc(100vh - 290px)'}
        columns={[
          CountriesShareColumn({
            countriesShareType: regionSegVal,
          }),
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default CountriesCard;
